// extracted by mini-css-extract-plugin
export default {"icon":"IconThreeDot-module__icon___u38p3","active":"IconThreeDot-module__active___lClVr"};